export { default } from './components/ShareBar'
